module.exports = __webpack_public_path__ + "static/media/boolean-icon.fc01dfc4.svg";